import { Warning, WarningOctagon } from '@phosphor-icons/react';
import type { ReportOverview } from '../types/analytics-api.types';
import { alertHeadline, alertWhy } from '../utils/analytics-labels';
import { fmtPct } from '../utils/report-format';

type ReportAlertStripProps = {
  alerts: ReportOverview['alerts'];
};

export function ReportAlertStrip({ alerts }: ReportAlertStripProps) {
  if (!alerts.length) return null;

  const worst = alerts[0].severity === 'critical' ? 'critical' : 'warning';
  const list = alerts.slice(0, 4);

  return (
    <div
      className={
        worst === 'critical'
          ? 'rounded-xl border border-[#E9A9A9] bg-[#FDF5F5] px-4 py-3.5'
          : 'rounded-xl border border-[#F0C98A] bg-[#FFFCF5] px-4 py-3.5'
      }
    >
      <p className="text-xs font-semibold uppercase tracking-wide text-neutral-900">
        Needs attention
      </p>
      <ul>
        {list.map((alert) => {
          const digits = alert.code === 'complaint-rate-high' || alert.threshold < 0.01 ? 2 : 1;
          return (
            <li
              key={`${alert.code}-${alert.campaignId ?? 'org'}`}
              className="mt-2 flex items-start gap-2"
            >
              {alert.severity === 'critical' ? (
                <WarningOctagon
                  className="mt-0.5 size-[15px] shrink-0 text-[#d03b3b]"
                  weight="fill"
                  aria-hidden
                />
              ) : (
                <Warning
                  className="mt-0.5 size-[15px] shrink-0 text-[#b07d10]"
                  weight="fill"
                  aria-hidden
                />
              )}
              <span className="min-w-0">
                <span className="block text-xs font-semibold text-neutral-900">
                  {alertHeadline(alert.code, fmtPct(alert.threshold, digits), alert.campaignName)} —{' '}
                  now {fmtPct(alert.value, digits)}
                </span>
                <span className="block text-xs text-neutral-600">{alertWhy(alert.code)}</span>
              </span>
            </li>
          );
        })}
      </ul>
      {alerts.length > 4 ? (
        <p className="mt-2 text-xs text-neutral-600">{alerts.length - 4} more in this range.</p>
      ) : null}
    </div>
  );
}
